webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALL_FILES = exports.ALL_FILES = 'ALL_FILES';
var ALL_FILES_SUCCESS = exports.ALL_FILES_SUCCESS = 'ALL_FILES_SUCCESS';
var ALL_FILES_FAILURE = exports.ALL_FILES_FAILURE = 'ALL_FILES_FAILURE';

var ERROR_MSG = exports.ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = exports.SUCCESS_MSG = 'SUCCESS_MSG';

var SIGNED_URL_FOR_UPLOAD = exports.SIGNED_URL_FOR_UPLOAD = 'SIGNED_URL_FOR_UPLOAD';
var SIGNED_URL_FOR_UPLOAD_SUCCESS = exports.SIGNED_URL_FOR_UPLOAD_SUCCESS = 'SIGNED_URL_FOR_UPLOAD_SUCCESS';
var SIGNED_URL_FOR_UPLOAD_FAILURE = exports.SIGNED_URL_FOR_UPLOAD_FAILURE = 'SIGNED_URL_FOR_UPLOAD_FAILURE';

var SIGNED_URL_FOR_DOWNLOAD = exports.SIGNED_URL_FOR_DOWNLOAD = 'SIGNED_URL_FOR_DOWNLOAD';
var SIGNED_URL_FOR_DOWNLOAD_SUCCESS = exports.SIGNED_URL_FOR_DOWNLOAD_SUCCESS = 'SIGNED_URL_FOR_DOWNLOAD_SUCCESS';
var SIGNED_URL_FOR_DOWNLOAD_FAILURE = exports.SIGNED_URL_FOR_DOWNLOAD_FAILURE = 'SIGNED_URL_FOR_DOWNLOAD_FAILURE';

var FILES_UPLOAD = exports.FILES_UPLOAD = 'FILES_UPLOAD';
var FILES_UPLOAD_SUCCESS = exports.FILES_UPLOAD_SUCCESS = 'FILES_UPLOAD_SUCCESS';

var FILES_DOWNLOAD = exports.FILES_DOWNLOAD = 'FILES_DOWNLOAD';
var FILES_DOWNLOAD_SUCCESS = exports.FILES_DOWNLOAD_SUCCESS = 'FILES_DOWNLOAD_SUCCESS';

var GET_USER_DETAILS = exports.GET_USER_DETAILS = 'GET_USER_DETAILS';
var GET_USER_DETAILS_SUCCESS = exports.GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
var GET_USER_DETAILS_FAILURE = exports.GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';

var GET_USER_TASK_DECISION_FLAG = exports.GET_USER_TASK_DECISION_FLAG = 'GET_TASK_DECISION_FLAG';
var GET_USER_TASK_DECISION_FLAG_SUCCESS = exports.GET_USER_TASK_DECISION_FLAG_SUCCESS = 'GET_TASK_DECISION_FLAG_SUCCESS';

var DROPZONE_CONFIG = exports.DROPZONE_CONFIG = 'DROPZONE_CONFIG';
var DROPZONE_CONFIG_SUCCESS = exports.DROPZONE_CONFIG_SUCCESS = 'DROPZONE_CONFIG_SUCCESS';

var DOWNLOADING = exports.DOWNLOADING = 'DOWNLOADING';
var DOWNLOADING_SUCCESS = exports.DOWNLOADING_SUCCESS = 'DOWNLOADING_SUCCESS';

var NOTIFY = exports.NOTIFY = 'NOTIFY';
var NOTIFY_SUCCESS = exports.NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';

var META_NOTIFY = exports.META_NOTIFY = 'NOTIFY';
var META_NOTIFY_SUCCESS = exports.META_NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(10);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(170);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _admin = __webpack_require__(80);

var _admin2 = _interopRequireDefault(_admin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [_admin2.default]
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(91);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(10);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(173);

var _vuex2 = _interopRequireDefault(_vuex);

var _getters = __webpack_require__(82);

var _mutations = __webpack_require__(83);

var _actions = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
exports.default = new _vuex2.default.Store({
  strict: true,
  state: {
    showLoader: false,
    files: [],
    signedurls: [],
    userid: {},
    dropzonedata: {},
    isDownloading: {},
    usertaskdecision: false
  },
  mutations: (0, _assign2.default)({}, _mutations.productMutations),
  getters: (0, _assign2.default)({}, _getters.productGetters),
  actions: (0, _assign2.default)({}, _actions.productActions)
});

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = {"accept_reject_popup":{"title_txt":"Welcome to DropZone!!!","text_msg":"You have been assigned to perfom your activities through the DropZone. Click 'Start Activity' to accept your assignment.","start_activity_btn":"START ACTIVITY","accept_reject_message":"To upload your completed task, you have to accept this task by clicking ‘Accept Task’ button.  Then you will able to see ‘Complete task’ button to proceed further.","accept_btn":"Accept Task","reject_btn":"Decline Task","reject_assignment_url":"Alternatively you can also reject this assignment"},"front_page":{"files_and_folders":"Files and Folders","filename":"File Name","size":"Size","date_uploaded":"Date Uploaded","complete_btn":"COMPLETE","download_btn":"Download","back_btn":"Back","oops_error_msg":"This URL has expired and is no longer active","expired_msg":"This URL seems to have expired and is no longer active.","support_msg":"To connect with our support team, please write us to","success_msg":"Task has been completed successfully","decline_msg":"Task has been declined successfully","select_lang":"Select language","welcome":"Welcome,"},"upload_page":{"upload_txt":"Upload Task File(s)","metadata_txt":"Metadata Details","upload_file":"Upload Files","drop_file_txt":"Drop your files here","choose_file_txt":"or <a>choose files</a> from your computer","next_btn":"Next","uploaded_file":"Uploaded Files","filename_note":"⚠️ Please avoid using special characters in file names; they are automatically replaced with underscores (_) during upload."},"upload_popup":{"ensure_upload_txt":"Ensure all files have been uploaded before navigating away from this page.","discard_uploadfile_txt":"Navigating away from this page will discard all uploaded files. Do you wish to continue?","no_review_upload":"No, let me review my uploads","yes_finish_upload":"Yes, finish my uploads","no_stay_page":"No, stay on this page","yes_discard_file":"Yes, discard my file(s)","no_upload_file":"No, let me upload file(s)","yes_skip_step":"Yes, skip this step","no_file_txt":"We observed that no files have been uploaded yet, do you wish to skip this step?"},"metadata_page":{"submit_btn":"SUBMIT","mandatory_txt":"marked fields are mandatory"},"error_popup_page":{"error":"Error","retry_msg":"Sorry, Something went wrong. Please try again.","relaunch_msg":"Sorry, Something went wrong. Please relaunch the URL."}}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = {"accept_reject_popup":{"title_txt":"Добро пожаловать в DropZone!!!","text_msg":"Вам назначено выполнение ваших действий через DropZone. Нажмите «Начать задание», чтобы принять назначение.","start_activity_btn":"НАЧАТЬ ЗАДАНИЕ","reject_assignment_url":"В качестве альтернативы вы также можете отклонить это задание"},"front_page":{"files_and_folders":"Файлы и папки","filename":"Имя файла","size":"Размер","date_uploaded":"Дата загрузки","complete_btn":"ЗАВЕРШИТЬ","download_btn":"Скачать","back_btn":"Назад","oops_error_msg":"Ссылка не активна, т.к. истек срок ее действия","expired_msg":"Эта ссылка, похоже, устарела и больше не активна.","support_msg":"Чтобы связаться с нашей службой поддержки, напишите нам на","success_msg":"Задача успешно выполнена","decline_msg":"Задача успешно отклонена","select_lang":"Выберите язык","welcome":"Добро пожаловать,"},"upload_page":{"upload_txt":"Загрузить файлы задания","metadata_txt":"Детали метаданных","upload_file":"Загрузить файлы","drop_file_txt":"Перетащите файлы сюда","choose_file_txt":"или <a>выберите файлы</a> на вашем компьютере","next_btn":"Далее","uploaded_file":"Загруженные файлы","filename_note":"⚠️ Пожалуйста, избегайте использования специальных символов в именах файлов; они автоматически заменяются подчеркиваниями (_) во время загрузки."},"upload_popup":{"ensure_upload_txt":"Убедитесь, что все файлы были загружены перед переходом с этой страницы.","discard_uploadfile_txt":"Переход с этой страницы приведет к удалению всех загруженных файлов. Вы хотите продолжить?","no_review_upload":"Нет, я хочу просмотреть свои загрузки","yes_finish_upload":"Да, завершить загрузку","no_stay_page":"Нет, остаться на этой странице","yes_discard_file":"Да, удалить мои файлы","no_upload_file":"Нет, я хочу загрузить файлы","yes_skip_step":"Да, пропустить этот шаг","no_file_txt":"Мы заметили, что файлы еще не были загружены. Хотите пропустить этот шаг?"},"metadata_page":{"submit_btn":"ОТПРАВИТЬ","mandatory_txt":"поля, отмеченные звездочкой, обязательны для заполнения"},"error_popup_page":{"error":"Ошибка","retry_msg":"Извините, что-то пошло не так. Пожалуйста, попробуйте снова.","relaunch_msg":"Извините, что-то пошло не так. Пожалуйста, перезапустите ссылку."}}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_BASE = exports.API_BASE = 'https://pa-s3access.sciencejournals.ru/api';
var META_API_BASE = exports.META_API_BASE = 'https://pa-metaapi.sciencejournals.ru/api';

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(10);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(57);

var _App2 = _interopRequireDefault(_App);

var _vueI18n = __webpack_require__(56);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _router = __webpack_require__(53);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(54);

var _store2 = _interopRequireDefault(_store);

var _en = __webpack_require__(58);

var _en2 = _interopRequireDefault(_en);

var _ru = __webpack_require__(59);

var _ru2 = _interopRequireDefault(_ru);

var _veeValidate = __webpack_require__(55);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;
_vue2.default.use(_veeValidate2.default);
_vue2.default.use(_vueI18n2.default);

exports.default = {
  data: function data() {
    return {
      englishlanguage: _en2.default, russianlanguage: _ru2.default
    };
  }
};


var messages = {
  en: {
    message: _en2.default
  },
  ru: {
    message: _ru2.default
  }
};

var i18n = new _vueI18n2.default({
  locale: 'en',
  messages: messages });

new _vue2.default({
  i18n: i18n,
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Index = __webpack_require__(156);

var _Index2 = _interopRequireDefault(_Index);

var _New = __webpack_require__(158);

var _New2 = _interopRequireDefault(_New);

var _Files = __webpack_require__(155);

var _Files2 = _interopRequireDefault(_Files);

var _Metadata = __webpack_require__(157);

var _Metadata2 = _interopRequireDefault(_Metadata);

var _Error = __webpack_require__(154);

var _Error2 = _interopRequireDefault(_Error);

var _Success = __webpack_require__(159);

var _Success2 = _interopRequireDefault(_Success);

var _Decline = __webpack_require__(153);

var _Decline2 = _interopRequireDefault(_Decline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Index',
  path: '/admin',
  component: _Index2.default,
  children: [{
    path: 'new',
    name: 'New',
    component: _New2.default
  }, {
    path: 'view',
    name: 'Files',
    component: _Files2.default
  }, {
    path: 'frozen',
    name: 'Frozen',
    component: _Error2.default
  }, {
    path: 'Success',
    name: 'Success',
    component: _Success2.default
  }, {
    path: 'Decline',
    name: 'Decline',
    component: _Decline2.default
  }, {
    path: 'metadata',
    name: 'Metadata',
    component: _Metadata2.default
  }]
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productActions = undefined;

var _promise = __webpack_require__(36);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(60);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(78);

var _mutationTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productActions = exports.productActions = {
  allFiles: function allFiles(_ref, payload) {
    var commit = _ref.commit;

    commit(_mutationTypes.ALL_FILES);
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_config.API_BASE + '/getDropzoneFiles', payload).then(function (response) {
        commit(_mutationTypes.ALL_FILES_SUCCESS, response.data);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  signedUrlForUpload: function signedUrlForUpload(_ref2, payload) {
    var commit = _ref2.commit;

    commit(_mutationTypes.SIGNED_URL_FOR_UPLOAD);
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_config.API_BASE + '/getSignedUrlForUpload', payload).then(function (response) {
        commit(_mutationTypes.SIGNED_URL_FOR_UPLOAD_SUCCESS, response.data);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  signedUrlForDownload: function signedUrlForDownload(_ref3, payload) {
    var commit = _ref3.commit;

    commit(_mutationTypes.SIGNED_URL_FOR_DOWNLOAD);
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_config.API_BASE + '/fileDownloadFromS3Path', payload).then(function (response) {
        commit(_mutationTypes.SIGNED_URL_FOR_DOWNLOAD_SUCCESS, response.data);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  getUserDetails: function getUserDetails(_ref4, payload) {
    var commit = _ref4.commit;

    commit(_mutationTypes.GET_USER_DETAILS);
    commit(_mutationTypes.GET_USER_DETAILS_SUCCESS, payload);
  },
  getUserTaskDecision: function getUserTaskDecision(_ref5, payload) {
    var commit = _ref5.commit;

    commit(_mutationTypes.GET_USER_TASK_DECISION_FLAG);
    commit(_mutationTypes.GET_USER_TASK_DECISION_FLAG_SUCCESS, payload);
  },
  dropzoneConfig: function dropzoneConfig(_ref6, payload) {
    var commit = _ref6.commit;

    commit(_mutationTypes.DROPZONE_CONFIG);
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.get(_config.API_BASE + '/getDropzoneConfig/' + payload, payload).then(function (response) {
        commit(_mutationTypes.DROPZONE_CONFIG_SUCCESS, response.data);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  notify: function notify(_ref7, payload) {
    var commit = _ref7.commit;

    commit(_mutationTypes.NOTIFY);
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_config.API_BASE + '/notify', payload).then(function (response) {
        commit(_mutationTypes.NOTIFY_SUCCESS, response.data);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateAcceptFlagFromDropzone: function updateAcceptFlagFromDropzone(_ref8, payload) {
    var commit = _ref8.commit;

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_config.API_BASE + '/updateAcceptFlagFromDropzone', payload).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateMetadata: function updateMetadata(_ref9, payload) {
    var commit = _ref9.commit;

    commit(_mutationTypes.META_NOTIFY);
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_config.META_API_BASE + '/setArticleJobflowProperties/' + payload.metadataid + '/' + payload.articlejobflowmetadataid, payload).then(function (response) {
        commit(_mutationTypes.META_NOTIFY_SUCCESS, response.data);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var productGetters = exports.productGetters = {
  allFiles: function allFiles(state, getters) {
    console.log('getters all files');
    return state.files;
  },
  signedUrlForUpload: function signedUrlForUpload(state, getters) {
    return state.signedurls;
  },
  signedUrlForDownload: function signedUrlForDownload(state, getters) {
    return state.signedurls;
  },
  getUserDetails: function getUserDetails(state) {
    return state.userid;
  },
  getUserTaskDecision: function getUserTaskDecision(state) {
    console.log('returning');
    console.log(state.usertaskdecision);
    return state.usertaskdecision;
  },
  dropzoneConfig: function dropzoneConfig(state) {
    return state.dropzonedata;
  }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productMutations = undefined;

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _productMutations;

var _mutationTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productMutations = exports.productMutations = (_productMutations = {}, (0, _defineProperty3.default)(_productMutations, _mutationTypes.ALL_FILES, function (state) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.ALL_FILES_SUCCESS, function (state, payload) {
  state.showLoader = false;
  state.files = payload;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.ERROR_MSG, function (state, payload) {
  state.showLoader = false;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.SIGNED_URL_FOR_UPLOAD, function (state, payload) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.SIGNED_URL_FOR_UPLOAD_SUCCESS, function (state, payload) {
  state.showLoader = false;
  state.signedurls = payload;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.SIGNED_URL_FOR_DOWNLOAD, function (state, payload) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.SIGNED_URL_FOR_DOWNLOAD_SUCCESS, function (state, payload) {
  state.signedurls = payload;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.GET_USER_DETAILS, function (state, payload) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.GET_USER_DETAILS_SUCCESS, function (state, payload) {
  state.showLoader = false;
  state.userid = payload;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.GET_USER_TASK_DECISION_FLAG, function (state) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.GET_USER_TASK_DECISION_FLAG_SUCCESS, function (state, payload) {
  state.showLoader = false;
  state.usertaskdecision = payload;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.FILES_UPLOAD_SUCCESS, function (state, payload) {}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.FILES_DOWNLOAD, function (state, payload) {
  state.showLoaded = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.FILES_DOWNLOAD_SUCCESS, function (state, payload) {
  state.showLoaded = false;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.DROPZONE_CONFIG, function (state) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.DROPZONE_CONFIG_SUCCESS, function (state, payload) {
  state.showLoader = false;
  state.dropzonedata = payload;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.DOWNLOADING, function (state) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.DOWNLOADING_SUCCESS, function (state) {
  state.showLoader = false;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.NOTIFY, function (state) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.NOTIFY_SUCCESS, function (state) {
  state.showLoader = false;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.META_NOTIFY, function (state) {
  state.showLoader = true;
}), (0, _defineProperty3.default)(_productMutations, _mutationTypes.META_NOTIFY_SUCCESS, function (state) {
  state.showLoader = false;
}), _productMutations);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toastr = __webpack_require__(148);

var _toastr2 = _interopRequireDefault(_toastr);

var _mutationTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  data: function data() {
    return {
      userId: ''
    };
  },
  created: function created() {
    this.userId = this.$route.query.userid;
    this.$store.subscribe(function (mutation) {
      if (mutation.payload) {
        switch (mutation.type) {
          case _mutationTypes.ERROR_MSG:
            _toastr2.default.error(mutation.payload.content, mutation.payload.title);
            break;
          case _mutationTypes.FILES_UPLOAD_SUCCESS:
            _toastr2.default.success('Files uploaded.', 'Success');
            break;
          case _mutationTypes.DOWNLOADING_SUCCESS:
            _toastr2.default.success('Files downloaded.', 'Success');
            break;
          case _mutationTypes.NOTIFY_SUCCESS:
            _toastr2.default.success('Notified.', 'Success');
            break;
        }
      }
    });
  },

  computed: {
    showLoader: function showLoader() {
      return this.$store.state.showLoader;
    }
  },
  methods: {
    clicked: function clicked(e) {
      e.preventDefault();
    },
    onDrpChange: function onDrpChange(e) {
      this.$i18n.locale = e.target.value;
      console.log(e);
    }
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dropzone = __webpack_require__(136);

var _dropzone2 = _interopRequireDefault(_dropzone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dropzone2.default.autoDiscover = false;

exports.default = {
  props: ['rejectReasonPopupFlag'],
  data: function data() {
    return {
      isFilesUploaded: false,
      isFileUploadInProgress: false,
      confirmationPoupFlag: false,
      uploadFileToServerConfirmationPoupFlag: false,
      discardFilesConfirmationPoupFlag: false
    };
  },
  created: function created() {
    if (this.$store.getters.allFiles.dropzoneConfig.delflag === 1) {
      this.$router.push({ name: 'Frozen' });
    }
    console.log('New files' + this.$store.getters.getUserDetails);
  },
  mounted: function mounted() {
    var vm = this;

    var options = {
      url: '/',

      method: 'put',

      sending: function sending(file, xhr) {
        var _send = xhr.send;
        xhr.send = function () {
          _send.call(xhr, file);
        };
      },

      parallelUploads: 1,
      timeout: 600000,
      uploadMultiple: true,
      addRemoveLinks: true,
      dictCancelUpload: '<span class="drpAllImgSvg crossImg"></span>',
      dictRemoveFile: '<span class="drpAllImgSvg crossImg"></span><span class="completedtxt">Completed</span><span class="failedtxt">Upload failed</span>',

      headers: { 'x-amz-server-side-encryption': 'AES256' },

      dictDefaultMessage: '<div><div class="msgDrop">' + this.$i18n.t('message.upload_page.drop_file_txt') + '</div><div class="uploadImg"></div><div class="msgChoose">' + this.$i18n.t('message.upload_page.choose_file_txt') + '</div></div>',

      autoProcessQueue: false,
      createImageThumbnails: false

    };

    console.log(this.$el);
    console.log(options);
    options.previewsContainer = '#previewContainer';
    this.dropzone = new _dropzone2.default(document.getElementById('drpContainer'), options);

    vm.dropzone.on('processing', function (file) {
      vm.dropzone.options.url = file.uploadURL;
    });

    vm.dropzone.on('addedfile', function (file) {
      var newName = file.name.replace(/[[\]`~!@#$%^&*()_|+\-=?;:'",<>/{}]/g, '_');
      console.log('Replaced File name----------');
      console.log(newName);
      file.newName = newName;
      file.previewElement.querySelector('.dz-filename span').textContent = newName;
      vm.isFilesUploaded = true;
    });

    vm.dropzone.on('queuecomplete', function (file) {
      console.log(vm.dropzone.getQueuedFiles().length);
      if (vm.dropzone.getUploadingFiles().length === 0 && vm.dropzone.getQueuedFiles().length === 0) {
        vm.isFileUploadInProgress = false;
        console.log('queue over');
        vm.$router.push({ name: 'Metadata' });
      }
    });
  },

  methods: {
    backButtonClick: function backButtonClick() {
      if (this.dropzone.files.length > 0) {
        this.discardFilesConfirmationPoupFlag = true;
      } else {
        this.$router.push({ name: 'Files' });
        var langDropdown = document.querySelector('#langDropdown');
        if (langDropdown !== undefined && langDropdown !== null) {
          langDropdown.querySelector('select').disabled = false;
        }
      }
    },
    moveToLandingPage: function moveToLandingPage() {
      this.$router.push({ name: 'Files' });
      var langDropdown = document.querySelector('#langDropdown');
      if (langDropdown !== undefined && langDropdown !== null) {
        langDropdown.querySelector('select').disabled = false;
      }
    },
    closeDiscardFilePopup: function closeDiscardFilePopup() {
      this.discardFilesConfirmationPoupFlag = false;
    },

    uploadFiles: function uploadFiles(e) {
      this.uploadFileToServerConfirmationPoupFlag = false;
      this.isFileUploadInProgress = true;
      var payload = {};
      payload.sessionid = this.$store.getters.getUserDetails;
      payload.files = [];
      var filesToUpload = this.dropzone.files.filter(this.getQueuedFiles);
      if (filesToUpload.length > 0) {
        for (var i = 0; i < filesToUpload.length; i++) {
          payload.files.push(filesToUpload[i].newName || filesToUpload[i].name);
        }
        this.$store.dispatch('signedUrlForUpload', payload).then(function () {
          var signedUrls = this.$store.getters.signedUrlForUpload;
          for (var j = 0; j < filesToUpload.length; j++) {
            this.processFiles(j, signedUrls[j], filesToUpload);
          }
        }.bind(this));
      } else {
        this.isFileUploadInProgress = false;
      }
    },
    getQueuedFiles: function getQueuedFiles(files) {
      return files.status === 'queued';
    },
    processFiles: function processFiles(index, url, filesToUpload) {
      setTimeout(function () {
        filesToUpload[index].uploadURL = url;
        this.dropzone.processFile(filesToUpload[index]);
      }.bind(this));
    },
    nextButtonClick: function nextButtonClick() {
      if (!this.isFileUploadInProgress) {
        if (this.dropzone.files.length === 0) {
          this.confirmationPoupFlag = true;
        } else {
          this.uploadFileToServerConfirmationPoupFlag = true;
        }
      }
    },
    closeConfirmationPopup: function closeConfirmationPopup() {
      this.confirmationPoupFlag = false;
    },
    closeUploadConfirmationPopup: function closeUploadConfirmationPopup() {
      this.uploadFileToServerConfirmationPoupFlag = false;
    },
    moveToMetadataPage: function moveToMetadataPage() {
      this.$router.push({ name: 'Metadata' });
    }
  }
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(5);

exports.default = {
  props: ['model', 'dynamicMetadataPopupFlag'],
  data: function data() {
    return {
      validationMessage: '',
      form: this.model.form,
      VALIDATION_MSG: { 'email': 'not a valid email id', 'alphaNumeric': 'only alphabets and numbers allowed', 'alphabets': 'only alphabets allowed', 'numeric': 'Not a valid number!' },
      errorMsg: this.model.errorMessage
    };
  },

  methods: {
    hideMetadataPopup: function hideMetadataPopup() {
      this.model.dynamicMetadataPopupFlag = false;
      console.log(this.model);
    },
    validateForm: function validateForm(validationType, value) {
      var regex = '';
      if (validationType === 'email') {
        var emails = value.replace(/\s/g, '').split(',');
        regex = /^([a-zA-Z0-9_]+)@([a-zA-Z0-9_]+)\.([a-zA-Z]{2,5})$/;
        for (var i = 0; i < emails.length; i++) {
          if (emails[i] !== '' && !regex.test(emails[i])) {
            return false;
          }
        }
        return true;
      } else if (validationType === 'alphaNumeric') {
        regex = /^[a-zA-Z0-9\s]+$/;
        return regex.test(value);
      } else if (validationType === 'alphabets') {
        regex = /^[A-z\s]+$/;
        return regex.test(value);
      } else if (validationType === 'numeric') {
        regex = /^\d+$/;
        return regex.test(value);
      }
    },
    changeDateFormat: function changeDateFormat(datevalue) {
      var today = new Date(datevalue);
      var dd = today.getDate();
      var mm = today.getMonth() + 1;

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      return mm + '-' + dd + '-' + yyyy;
    },
    submit: function submit() {
      var isValidationFail = false;
      for (var index in this.model.dynamicUiData) {
        var model = this.model.dynamicUiData[index];
        if (this.form[model.key] === undefined || this.form[model.key] === '') {
          console.log(this.form[model.key]);
          if (model.required) {
            if (model.displayType === 'checkbox') {
              this.form[model.key] = false;
            } else {
              this.errorMsg[model.key] = model.key + ' is required';
              isValidationFail = true;
              break;
            }
          }
        } else {
          this.errorMsg[model.key] = '';
        }
        if (model.validation_type != null) {
          if (!this.validateForm(model.validation_type, this.form[model.key])) {
            this.errorMsg[model.key] = this.VALIDATION_MSG[model.validation_type];
            isValidationFail = true;
            break;
          } else {
            this.errorMsg[model.key] = '';
          }
        }
      }
      if (!isValidationFail) {
        var payload = {};
        var articleMetadataValues = {};
        var jobFlowMetadataValues = {};
        for (var indexForDate in this.model.dynamicUiData) {
          var modelData = this.model.dynamicUiData[indexForDate];
          if (modelData.displayType === 'datefield') {
            this.form[modelData.key] = this.changeDateFormat(this.form[modelData.key]);
            console.log(this.form[modelData.key]);
          }
          if (modelData.isjobflowlevel) {
            jobFlowMetadataValues[modelData.key] = this.form[modelData.key];
          } else {
            articleMetadataValues[modelData.key] = this.form[modelData.key];
          }
        }
        payload.sessionid = this.$store.getters.getUserDetails;
        payload.status = this.model.status;
        payload.jobflowmetadataid = this.model.jobflowmetadataid;
        payload.metadataid = this.model.metadataid;
        payload['metadata'] = articleMetadataValues;
        payload['jobflowmetadata'] = [];
        payload['jobflowmetadata'].push({ 'metadata': jobFlowMetadataValues });
        this.$store.dispatch('notify', payload).then(function () {
          this.model.dynamicMetadataPopupFlag = false;
          this.$router.push({ name: 'Frozen' });
        }.bind(this)).catch(function () {
          this.$store.commit(_mutationTypes.ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.retry_msg')
          });
        }.bind(this));
      } else {
        var elmnt = document.getElementById(model.key);
        elmnt.scrollIntoView();
      }
    }
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(36);

var _promise2 = _interopRequireDefault(_promise);

var _jszip = __webpack_require__(146);

var _jszip2 = _interopRequireDefault(_jszip);

var _jszipUtils = __webpack_require__(145);

var _jszipUtils2 = _interopRequireDefault(_jszipUtils);

var _fileSaver = __webpack_require__(142);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _vue = __webpack_require__(10);

var _vue2 = _interopRequireDefault(_vue);

var _DynamicUiForm = __webpack_require__(152);

var _DynamicUiForm2 = _interopRequireDefault(_DynamicUiForm);

var _vuejsDialog = __webpack_require__(172);

var _vuejsDialog2 = _interopRequireDefault(_vuejsDialog);

var _mutationTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuejsDialog2.default);

var zip = new _jszip2.default();
var zipname;
exports.default = {
  data: function data() {
    return {
      files: [],
      downloadAll: false,
      rejectReason: '',
      selectedFiles: [],
      taskDecisionFlag: false,
      acceptFlag: 1,
      model: {
        'dynamicUiData': [],
        'dynamicMetadataPopupFlag': false,
        'acceptRejectFlag': true,
        'form': {},
        'errorMsg': {}
      },
      crumbs: []
    };
  },

  computed: {},
  created: function created() {
    this.taskDecisionFlag = this.$store.getters.getUserTaskDecision;
    console.log('View files:' + this.$store.getters.getUserDetails);
    this.crumbs.push({ displayName: 'Home', path: '' });
    var payload = { sessionid: this.$store.getters.getUserDetails };
    this.$store.dispatch('allFiles', payload).then(function () {
      this.selectedFiles = [];
      console.log(this.$store.getters.allFiles);
      if (this.$store.getters.allFiles.dropzoneConfig.delflag === 1) {
        this.$router.push({ name: 'Frozen' });
      } else {
        console.log(this.$store.getters.getUserTaskDecision);

        this.files = this.$store.getters.allFiles.files;
        this.acceptFlag = this.$store.getters.allFiles.dropzoneConfig.acceptflag;
        console.log(this.$store.getters.allFiles.dropzoneConfig.propertydata);
        this.model.dynamicUiData = JSON.parse(this.$store.getters.allFiles.dropzoneConfig.propertydata);
        this.model.metadataid = this.$store.getters.allFiles.dropzoneConfig.metadataid;
        this.model.jobflowmetadataid = this.$store.getters.allFiles.dropzoneConfig.jobflowmetadataid;
        this.downloadAll = this.files.length > 0;
      }
    }.bind(this)).catch(function () {
      this.$store.commit(_mutationTypes.ERROR_MSG, {
        type: 'error',
        title: this.$t('message.error_popup_page.error'),
        content: this.$t('message.error_popup_page.relaunch_msg')
      });
    }.bind(this));
  },

  methods: {
    accept: function accept() {
      var payload = {};
      payload.sessionid = this.$store.getters.getUserDetails;
      this.$store.dispatch('updateAcceptFlagFromDropzone', payload).then(function () {
        this.acceptFlag = 1;
      }.bind(this)).catch(function () {
        this.$store.commit(_mutationTypes.ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.retry_msg')
        });
      }.bind(this));
    },
    rejectUserTask: function rejectUserTask() {
      var payload = {};
      payload.sessionid = this.$store.getters.getUserDetails;
      payload.status = false;
      this.$store.dispatch('notify', payload).then(function () {
        this.$router.push({ name: 'Decline' });
      }.bind(this)).catch(function () {
        this.$store.commit(_mutationTypes.ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.retry_msg')
        });
      }.bind(this));
    },
    downloadFromRow: function downloadFromRow(file) {
      console.log('Download files:' + this.$store.getters.getUserDetails);
      var currentFolderPath = this.crumbs.slice(1).map(function (crumb) {
        return crumb.displayName;
      }).join('/');

      this.$store.commit(_mutationTypes.DOWNLOADING);
      var payload = { sessionid: this.$store.getters.getUserDetails, selectedFiles: [file], folder: currentFolderPath };
      console.log(payload);
      this.$store.dispatch('signedUrlForDownload', payload).then(function () {
        console.log(this.$store.getters.signedUrlForDownload);
        var signedUrls = this.$store.getters.signedUrlForDownload;
        this.downloadFile(signedUrls);
      }.bind(this));
    },
    downloadAllFiles: function downloadAllFiles() {
      if (this.selectedFiles.length > 0) {
        console.log('Download files:' + this.$store.getters.getUserDetails);
        var currentFolderPath = this.crumbs.slice(1).map(function (crumb) {
          return crumb.displayName;
        }).join('/');
        this.$store.commit(_mutationTypes.DOWNLOADING);
        var payload = { sessionid: this.$store.getters.getUserDetails, selectedFiles: this.selectedFiles, folder: currentFolderPath };
        console.log(payload);
        this.$store.dispatch('signedUrlForDownload', payload).then(function () {
          console.log(this.$store.getters.signedUrlForDownload);
          var signedUrls = this.$store.getters.signedUrlForDownload;
          var requests = [];
          zip = new _jszip2.default();
          var zipFolder;
          if (signedUrls.length === 1) {
            this.downloadFile(signedUrls);
          } else {
            for (var j = 0; j < signedUrls.length; j++) {
              requests.push(this.request(signedUrls[j], zipFolder, zip));
            }
            zipname = this.getZipname(signedUrls[0]);
            _promise2.default.all(requests).then(function () {
              this.prepareZip(zipname, zip);
            }.bind(this));
          }
          for (var k = 0; k < this.selectedFiles.length; j++) {
            this.toggle_downladAll(this.selectedFiles[k]);
          }
        }.bind(this));
      }
    },
    downloadFile: function downloadFile(signedUrls) {
      _jszipUtils2.default.getBinaryContent(signedUrls[0].key, function (err, data) {
        console.log(err);
        console.log(data);
        var blob = new Blob([data], { type: 'blob' });
        _fileSaver2.default.saveAs(blob, signedUrls[0].name);
        this.$store.commit(_mutationTypes.DOWNLOADING_SUCCESS, {});
      }.bind(this));
    },
    request: function request(urlObj, zipFolder, zip) {
      return new _promise2.default(function (resolve) {
        _jszipUtils2.default.getBinaryContent(urlObj.key, function (err, data) {
          console.log(err);
          var folderpath = urlObj.path;
          var index = folderpath.indexOf('Article');
          if (index !== -1) {
            folderpath = folderpath.slice(index);
          } else {
            index = folderpath.indexOf('Issue');
            if (index !== -1) {
              folderpath = folderpath.slice(index);
            }
          }
          zipFolder = zip.folder(folderpath);
          zipFolder.file(urlObj.name, data, { binary: true });
          resolve();
        });
      });
    },
    getZipname: function getZipname(signedUrl) {
      var folderpathparts = signedUrl.path.split('/');
      var indexParts = folderpathparts.indexOf('Article');
      if (indexParts !== -1) {
        console.log(folderpathparts[indexParts]);
      } else {
        indexParts = folderpathparts.indexOf('Issue');
        if (indexParts !== -1) {
          console.log(folderpathparts[indexParts]);
        }
      }
      zipname = folderpathparts[indexParts + 1] + '_' + folderpathparts[indexParts + 3];
      console.log(zipname);
      console.log('+++++++++++++++++++++++');
      return zipname;
    },
    prepareZip: function prepareZip(zipname, zip) {
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        _fileSaver2.default.saveAs(content, zipname + '.zip');
        this.$store.commit(_mutationTypes.DOWNLOADING_SUCCESS, {});
      }.bind(this));
    },
    toggle: function toggle(file) {
      if (file.isfolder) {
        this.openFolder(file);
        return;
      }
      var fileIndex = this.selectedFiles.indexOf(file);
      if (fileIndex === -1) this.selectedFiles.push(file);else this.selectedFiles.splice(fileIndex, 1);
      if (typeof file.ischeck === 'undefined') {
        _vue2.default.set(file, 'ischeck', false);
      }
      if (file.ischeck) file.ischeck = false;else file.ischeck = true;
    },
    toggle_downladAll: function toggle_downladAll(file) {
      var fileIndex = this.selectedFiles.indexOf(file);
      if (fileIndex === -1) this.selectedFiles.push(file);else this.selectedFiles.splice(fileIndex, 1);
      if (typeof file.ischeck === 'undefined') {
        _vue2.default.set(file, 'ischeck', false);
      }
      if (file.ischeck) file.ischeck = false;else file.ischeck = true;
    },
    folderselect: function folderselect(file) {
      var fileIndex = this.selectedFiles.indexOf(file);
      if (fileIndex === -1) this.selectedFiles.push(file);else this.selectedFiles.splice(fileIndex, 1);
      if (typeof file.ischeck === 'undefined') {
        _vue2.default.set(file, 'ischeck', false);
      }
      if (file.ischeck) file.ischeck = false;else file.ischeck = true;
    },
    openFolder: function openFolder(file) {
      console.log('View files:' + this.$store.getters.getUserDetails);
      this.crumbs.push({ displayName: file.filename, path: file.filename });

      var currentFolderPath = this.crumbs.slice(1).map(function (crumb) {
        return crumb.displayName;
      }).join('/');
      console.log(currentFolderPath);

      var payload = { sessionid: this.$store.getters.getUserDetails, folder: currentFolderPath };
      this.$store.dispatch('allFiles', payload).then(function () {
        this.selectedFiles = [];
        this.files = this.$store.getters.allFiles.files;
        if (this.files.length > 0) this.downloadAll = true;
      }.bind(this)).catch(function () {
        this.$store.commit(_mutationTypes.ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.relaunch_msg')
        });
      }.bind(this));
    },
    navigate: function navigate(file, key) {
      console.log('View files:' + this.$store.getters.getUserDetails);
      this.crumbs.splice(key + 1, this.crumbs.length);

      var currentFolderPath = this.crumbs.slice(1).map(function (crumb) {
        return crumb.displayName;
      }).join('/');
      var payload = { sessionid: this.$store.getters.getUserDetails };
      if (currentFolderPath !== '') {
        payload.folder = currentFolderPath;
      }
      this.$store.dispatch('allFiles', payload).then(function () {
        this.selectedFiles = [];
        this.files = this.$store.getters.allFiles.files;
        if (this.files.length > 0) this.downloadAll = true;
      }.bind(this)).catch(function () {
        this.$store.commit(_mutationTypes.ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.relaunch_msg')
        });
      }.bind(this));
    },
    notify: function notify(userStatus) {
      console.log(userStatus);
      console.log('Notify for:' + this.$store.getters.getUserDetails);
      this.$dialog.confirm('This action will freeze the dropzone url').then(function () {
        console.log('clicked');
        console.log(this);
        this.$store.commit(_mutationTypes.NOTIFY);
        var payload = { sessionid: this.$store.getters.getUserDetails, status: 'accepted' };
        this.$store.dispatch('notify', payload).then(function () {
          this.$router.push({ name: 'Frozen' });
          this.$store.commit(_mutationTypes.NOTIFY_SUCCESS, {});
        }.bind(this)).catch(function () {
          this.$store.commit(_mutationTypes.ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.relaunch_msg')
          });
        }.bind(this));
      }.bind(this));
    },
    showRejectPopup: function showRejectPopup() {
      this.taskDecisionFlag = true;
    },
    acceptTask: function acceptTask() {
      this.$store.dispatch('getUserTaskDecision', true);
      this.taskDecisionFlag = this.$store.getters.getUserTaskDecision;
    },
    showMetadataPopup: function showMetadataPopup(status) {
      this.model.form = {};
      this.model.errorMessage = {};
      for (var i = 0; i < this.model.dynamicUiData.length; i++) {
        if (this.model.dynamicUiData[i].isdefault) {
          this.model.form[this.model.dynamicUiData[i].key] = this.model.dynamicUiData[i].defaultvalue;
        }
        this.model.errorMessage[this.model.dynamicUiData[i].key] = '';
      }
      this.model.status = status;
      this.model.dynamicMetadataPopupFlag = true;
    },
    hideMetadataPopup: function hideMetadataPopup() {
      this.model.dynamicMetadataPopupFlag = false;
    },
    submitMetadataPopup: function submitMetadataPopup() {
      alert('submit');
    },
    completeButtonClick: function completeButtonClick() {
      this.$router.push({ name: 'New' });
      var langDropdown = document.querySelector('#langDropdown');
      if (langDropdown !== undefined && langDropdown !== null) {
        langDropdown.querySelector('select').disabled = true;
      }
    },
    reject: function reject() {
      console.log('Notify for:' + this.$store.getters.getUserDetails);
      this.$store.commit(_mutationTypes.NOTIFY);
      var payload = { sessionid: this.$store.getters.getUserDetails, status: 'rejected', reason: this.rejectReason };
      console.log(this.rejectReason);
      this.$store.dispatch('notify', payload).then(function () {
        this.$router.push({ name: 'Frozen' });
        this.$store.commit(_mutationTypes.NOTIFY_SUCCESS, {});
        this.taskDecisionFlag = false;
      }.bind(this)).catch(function () {
        this.taskDecisionFlag = false;
        this.$store.commit(_mutationTypes.ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.relaunch_msg')
        });
      }.bind(this));
    }
  },
  components: {
    'dynamic-ui-form': _DynamicUiForm2.default
  }
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(5);

exports.default = {
  data: function data() {
    return {
      dropzoneConfig: {}
    };
  },
  created: function created() {
    this.loadPage();
    this.$store.subscribe(function (mutation) {
      if (mutation.payload) {
        switch (mutation.type) {
          case _mutationTypes.NOTIFY_SUCCESS:
            this.dropzoneConfig.delflag = 1;
            break;
        }
      }
    }.bind(this));
  },

  computed: {},
  methods: {
    loadPage: function loadPage() {
      this.$store.dispatch('getUserDetails', this.$route.query.userid);
      this.$store.dispatch('dropzoneConfig', this.$route.query.userid).then(function () {
        this.dropzoneConfig = this.$store.getters.dropzoneConfig;
        if (this.dropzoneConfig.delflag === 1) this.$router.push({ name: 'Frozen' });else this.$router.push({ name: 'Files' });
      }.bind(this)).catch(function () {
        this.$store.commit(_mutationTypes.ERROR_MSG, {
          type: 'error',
          title: this.$t('message.error_popup_page.error'),
          content: this.$t('message.error_popup_page.retry_msg')
        });
      }.bind(this));
    }
  }
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(5);

var _vue = __webpack_require__(10);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      VALIDATION_MSG: { 'email': 'not a valid email id', 'alphaNumeric': 'only alphabets and numbers allowed', 'alphabets': 'only alphabets allowed', 'numeric': 'Not a valid number!' },
      form: {},
      'errorMsg': {},
      model: {
        'status': true,
        'dynamicUiData': [],
        'dispMetadataFlag': '',
        'filteredDynamicUiData': [],
        'dynamicMetadataPopupFlag': false
      }
    };
  },
  created: function created() {
    console.log('View files:' + this.$store.getters.getUserDetails);
    var payload = { sessionid: this.$store.getters.getUserDetails };
    this.$store.dispatch('allFiles', payload).then(function () {
      if (this.$store.getters.allFiles.dropzoneConfig.delflag === 1) {
        this.$router.push({ name: 'Frozen' });
      } else {
        console.log(this.$store.getters.allFiles.dropzoneConfig.propertydata);
        this.form = {};
        this.model.dynamicUiData = JSON.parse(this.$store.getters.allFiles.dropzoneConfig.propertydata);
        for (var arrIndex = 0; arrIndex < this.model.dynamicUiData.length; arrIndex++) {
          if (this.model.dynamicUiData[arrIndex].uidispflag) {
            this.model.filteredDynamicUiData.push(this.model.dynamicUiData[arrIndex]);
            this.model.dispMetadataFlag = 1;
          }
        }
        if (this.model.dispMetadataFlag !== 1) {
          this.model.dispMetadataFlag = 0;
        }
        this.model.dynamicUiData = this.model.filteredDynamicUiData;
        for (var i = 0; i < this.model.dynamicUiData.length; i++) {
          if (this.model.dynamicUiData[i].isdefault) {
            this.form[this.model.dynamicUiData[i].key] = this.model.dynamicUiData[i].defaultvalue;
          }
          if (this.$i18n.locale === 'en') {
            this.model.dynamicUiData[i].displayname = this.model.dynamicUiData[i].englishdisplayname;
          } else {
            this.model.dynamicUiData[i].displayname = this.model.dynamicUiData[i].russiandisplayname;
          }
          console.log(this.model.dynamicUiData);
          _vue2.default.set(this.errorMsg, this.model.dynamicUiData[i].key, '');
        }
      }
    }.bind(this)).catch(function (msg) {
      this.$store.commit(_mutationTypes.ERROR_MSG, {
        type: 'error',
        title: msg,
        content: 'Sorry, hai Something went wrong. Please relaunch the URL.'
      });
    }.bind(this));
  },

  methods: {
    backButtonClick: function backButtonClick() {
      this.$router.push({ name: 'New' });
    },
    hideMetadataPopup: function hideMetadataPopup() {
      this.model.dynamicMetadataPopupFlag = false;
      console.log(this.model);
    },
    validateForm: function validateForm(validationType, value) {
      var regex = '';
      if (validationType === 'email') {
        var emails = value.replace(/\s/g, '').split(',');
        regex = /^([a-zA-Z0-9_]+)@([a-zA-Z0-9_]+)\.([a-zA-Z]{2,5})$/;
        for (var i = 0; i < emails.length; i++) {
          if (emails[i] !== '' && !regex.test(emails[i])) {
            return false;
          }
        }
        return true;
      } else if (validationType === 'alphaNumeric') {
        regex = /^[a-zA-Z0-9\s]+$/;
        return regex.test(value);
      } else if (validationType === 'alphabets') {
        regex = /^[A-z\s]+$/;
        return regex.test(value);
      } else if (validationType === 'numeric') {
        regex = /^\d+$/;
        return regex.test(value);
      }
    },
    changeDateFormat: function changeDateFormat(datevalue) {
      var today = new Date(datevalue);
      var dd = today.getDate();
      var mm = today.getMonth() + 1;

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      return mm + '-' + dd + '-' + yyyy;
    },
    submit: function submit() {
      var isValidationFail = false;
      console.log(this.model.dynamicUiData);
      for (var index in this.model.dynamicUiData) {
        var model = this.model.dynamicUiData[index];
        if (this.form[model.key] === undefined || this.form[model.key] === '') {
          console.log(this.form[model.key]);
          if (model.required) {
            this.errorMsg[model.key] = model.key + ' is required';
            isValidationFail = true;
            break;
          }
          if (model.displayType === 'checkbox') {
            this.form[model.key] = false;
          } else {
            this.form[model.key] = '';
          }
        } else {
          this.errorMsg[model.key] = '';
        }
        if (model.validation_type != null) {
          if (!this.validateForm(model.validation_type, this.form[model.key])) {
            this.errorMsg[model.key] = this.VALIDATION_MSG[model.validation_type];
            isValidationFail = true;
            break;
          } else {
            this.errorMsg[model.key] = '';
          }
        }
      }
      if (!isValidationFail) {
        var payload = {};
        var articleMetadataValues = {};
        var jobFlowMetadataValues = {};
        for (var indexForDate in this.model.dynamicUiData) {
          var modelData = this.model.dynamicUiData[indexForDate];
          if (modelData.displayType === 'datefield') {
            this.form[modelData.key] = this.changeDateFormat(this.form[modelData.key]);
            console.log(this.form[modelData.key]);
          }
          if (modelData.isjobflowlevel) {
            jobFlowMetadataValues[modelData.key] = this.form[modelData.key];
          } else {
            articleMetadataValues[modelData.key] = this.form[modelData.key];
          }
        }
        payload.sessionid = this.$store.getters.getUserDetails;
        payload.status = this.model.status;
        payload.jobflowmetadataid = this.model.jobflowmetadataid;
        payload.metadataid = this.model.metadataid;
        payload['metadata'] = articleMetadataValues;
        payload['jobflowmetadata'] = [];
        payload['jobflowmetadata'].push({ 'metadata': jobFlowMetadataValues });
        this.$store.dispatch('notify', payload).then(function () {
          this.model.dynamicMetadataPopupFlag = false;
          this.$router.push({ name: 'Success' });
        }.bind(this)).catch(function () {
          this.$store.commit(_mutationTypes.ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.retry_msg')
          });
        }.bind(this));
      } else {
        var elmnt = document.getElementById(model.key);
        elmnt.scrollIntoView();
      }
    }
  }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DropzoneFormNew = __webpack_require__(151);

var _DropzoneFormNew2 = _interopRequireDefault(_DropzoneFormNew);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      model: {}
    };
  },
  created: function created() {},

  computed: {},
  methods: {},
  components: {
    'dropzone-form': _DropzoneFormNew2.default
  }
};

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.crumbs.length > 1) ? _c('div', {
    staticClass: "col-lg-12 pd-top-15"
  }, [_c('span', {
    staticClass: "backText",
    on: {
      "click": function($event) {
        return _vm.navigate(_vm.crumbs[_vm.crumbs.length - 1], _vm.crumbs.length - 2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" " + _vm._s(_vm.$t("message.front_page.back_btn")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    class: [{
      'pd-top-15': (_vm.crumbs.length > 1)
    }, {
      'pd-top-30': !(_vm.crumbs.length > 1)
    }]
  }, [(_vm.acceptFlag == 0) ? _c('div', {
    staticClass: "userResponseHolder"
  }, [_c('span', {
    staticClass: "acceptRejectText"
  }, [_vm._v(_vm._s(_vm.$t("message.accept_reject_popup.accept_reject_message")))]), _vm._v(" "), _c('div', {
    staticClass: "acceptRejectBtns"
  }, [_c('button', {
    staticClass: "rejectBtn",
    on: {
      "click": function($event) {
        return _vm.rejectUserTask()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.accept_reject_popup.reject_btn")))]), _vm._v(" "), _c('button', {
    staticClass: "acceptBtn",
    on: {
      "click": function($event) {
        return _vm.accept()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.accept_reject_popup.accept_btn")))])])]) : _c('div', [_c('span', {
    staticClass: "folderTxtHolder"
  }, [_c('div', {
    staticClass: "filesAndFoldersTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.accept_reject_popup.start_activity_btn")))]), _vm._v(" "), (_vm.crumbs.length > 1) ? _c('div', {
    staticClass: "foldersTxt"
  }, [_vm._v(_vm._s(_vm.crumbs[_vm.crumbs.length - 1].displayName))]) : _vm._e()]), _vm._v(" "), (_vm.crumbs.length <= 1) ? _c('span', {
    staticClass: "fltRight"
  }, [_c('button', {
    staticClass: "completeTask",
    on: {
      "click": function($event) {
        return _vm.completeButtonClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.complete_btn")))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-12 pd-top-40"
  }, [_c('div', {
    staticClass: "headerList"
  }, [_c('span', {
    staticClass: "wd35"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.filename")))]), _vm._v(" "), _c('span', {
    staticClass: "wd20"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.size")))]), _vm._v(" "), _c('span', {
    staticClass: "wd20"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.date_uploaded")))]), _vm._v(" "), _c('span', {
    staticClass: "downloadHolder",
    on: {
      "click": _vm.downloadAllFiles
    }
  }, [_c('span', {
    staticClass: "drpAllImgSvg downloadIcon",
    class: [{
      'enable': (this.selectedFiles.length > 0)
    }]
  }), _vm._v(" "), _c('span', {
    staticClass: "txtDownload",
    class: [{
      'enable': (this.selectedFiles.length > 0)
    }]
  }, [_vm._v(" " + _vm._s(_vm.$t("message.front_page.download_btn")))])])]), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('div', {
      staticClass: "filesAndFoldersList"
    }, [_c('div', {
      staticClass: "rowholder cursPointer",
      class: [{
        'selected': file.ischeck
      }],
      on: {
        "click": function($event) {
          return _vm.toggle(file)
        }
      }
    }, [_c('span', {
      staticClass: "wd35"
    }, [(file.isfolder) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (file.ischeck),
        expression: "file.ischeck"
      }],
      staticStyle: {
        "width": "19px",
        "height": "19px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(file.ischeck) ? _vm._i(file.ischeck, null) > -1 : (file.ischeck)
      },
      on: {
        "click": [function($event) {
          return _vm.folderselect(file)
        }, function($event) {
          $event.stopPropagation();
        }],
        "change": function($event) {
          var $$a = file.ischeck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(file, "ischeck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(file, "ischeck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(file, "ischeck", $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (file.isfolder) ? _c('span', {
      staticClass: "folderImg drpAllImgSvg"
    }) : _c('span', {
      staticClass: "drpAllImgSvg",
      class: [{
        'tickImg': file.ischeck
      }, {
        'checkImg': !file.ischeck
      }]
    }), _vm._v(" "), _c('span', {
      staticClass: "nameHolderText"
    }, [_vm._v(_vm._s(file.filename))])]), _vm._v(" "), _c('span', {
      staticClass: "wd20 sizeHolderText"
    }, [_vm._v(_vm._s(file.size))]), _vm._v(" "), _c('span', {
      staticClass: "wd20"
    }, [_c('span', {
      staticClass: "dateHolderText"
    }, [_vm._v(_vm._s(file.lastmodified.substr(0, file.lastmodified.indexOf(' '))))]), _vm._v(" "), _c('span', {
      staticClass: "timeHolderText"
    }, [_vm._v(_vm._s(file.lastmodified.substr(file.lastmodified.indexOf(' ') + 1)))])]), _vm._v(" "), (file.isfolder) ? _c('span', {
      staticClass: "wd15"
    }) : _c('span', {
      staticClass: "wd15 downloadText",
      on: {
        "click": [function($event) {
          $event.stopPropagation();
        }, function($event) {
          return _vm.downloadFromRow(file)
        }]
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("message.front_page.download_btn")))])])])])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "successHolder"
  }, [_c('div', {
    staticClass: "drpAllImgSvg successImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "submittedTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.success_msg")))])])])
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "successHolder"
  }, [_c('div', {
    staticClass: "drpAllImgSvg errorImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "submittedTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.oops_error_msg")))])]), _vm._v(" "), _c('div', {
    staticClass: "footerHolder"
  }, [_c('div', {
    staticClass: "supportText"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.support_msg")))]), _vm._v(" "), _c('div', {
    staticClass: "supportEmailId"
  }, [_vm._v("publishingsystem@sciencejournals.ru")])])])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerDiv"
  }, [_c('span', {
    staticClass: "uploadTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.upload_txt")))]), _vm._v(" "), _c('span', {
    staticClass: "metadataTxt inprogressTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.metadata_txt")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', {
    staticClass: "filesAndFoldersTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.metadata_txt")))]), _vm._v(" "), _c('span', {
    staticClass: "fltRight"
  }, [_c('button', {
    staticClass: "completeTask nextPosition",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.metadata_page.submit_btn")))])])]), _vm._v(" "), _c('div', {
    staticClass: "metadataHolder col-lg-12 tp15"
  }, [(this.model.dispMetadataFlag === 0) ? _c('div', {
    staticClass: "nometadataMessage"
  }, [_vm._v("You are not required to provide any Metadata updates here! Please proceed to Submit ")]) : _vm._e(), _vm._v(" "), (this.model.dispMetadataFlag === 1) ? _c('div', {
    staticClass: "metaDetails"
  }, [_c('span', {
    staticClass: "markedMandatory"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.$t("message.metadata_page.mandatory_txt")))]), _vm._v(" "), _vm._l((_vm.model.dynamicUiData), function(component) {
    return _c('div', {
      staticClass: "mg-top-50"
    }, [(component.displayType == 'textfield') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "type": "text",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'textarea') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "rows": "3",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'combobox') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form, component.key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((component.listvalues), function(listvalue) {
      return _c('option', {
        domProps: {
          "value": listvalue.key
        }
      }, [_vm._v(_vm._s(listvalue.displayname))])
    }), 0), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'datefield') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "type": "date",
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'checkbox') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[component.key]) ? _vm._i(_vm.form[component.key], null) > -1 : (_vm.form[component.key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form[component.key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, component.key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, component.key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, component.key, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkKey"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('div', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'number') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e()])
  })], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "middleHolder"
  }, [_c('span', {
    staticClass: "completedTask"
  }, [_c('i', {
    staticClass: "tickMark fa fa-check"
  })]), _vm._v(" "), _c('span', {
    staticClass: "connectingLine inprogress"
  }), _vm._v(" "), _c('span', {
    staticClass: "pendingTask inprogress"
  })])
}]}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "successHolder"
  }, [_c('div', {
    staticClass: "drpAllImgSvg successImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "submittedTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.decline_msg")))])])])
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "header_dropzone"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    staticClass: "overlay"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav__left"
  }, [_c('li', [_c('span', {
    on: {
      "!click": function($event) {
        return _vm.clicked.apply(null, arguments)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(150),
      "alt": "logo"
    }
  })])])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('ul', {
    staticClass: "nav__right"
  }, [_c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "grey_text dis_blk"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.welcome")))]), _vm._v(" "), _c('span', {
    staticClass: "fntRoboto"
  }, [_vm._v(_vm._s(_vm.userId)), _c('span', {
    staticClass: "grey_text_author"
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "grey_text dis_blk fntRoboto"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.select_lang")))]), _vm._v(" "), _c('span', {
    staticClass: "blue_text fntRoboto",
    attrs: {
      "id": "langDropdown"
    }
  }, [_c('select', {
    on: {
      "change": _vm.onDrpChange
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("русский")])])])])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "loaderImg"
  }, [_c('img', {
    staticClass: "align_center_screen",
    attrs: {
      "src": __webpack_require__(149),
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "separatorBlock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "drpText"
  }, [_vm._v("Dropzone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "separatorBlock sb32"
  })])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.isFileUploadInProgress) ? _c('div', {
    staticClass: "screen screenLoader"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), (_vm.confirmationPoupFlag) ? _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "drpPopup"
  }, [_c('div', {
    staticClass: "decisionTitle"
  }, [_c('div', {
    staticClass: "confirmationTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_file_txt")))])]), _vm._v(" "), _c('div', {
    staticClass: "drpPopupBtnHolder"
  }, [_c('span', {
    staticClass: "leftBtnPopup",
    on: {
      "click": function($event) {
        return _vm.closeConfirmationPopup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_upload_file")))]), _vm._v(" "), _c('span', {
    staticClass: "rightBtnPopup",
    on: {
      "click": function($event) {
        return _vm.moveToMetadataPage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.yes_skip_step")))])])])]) : _vm._e(), _vm._v(" "), (_vm.uploadFileToServerConfirmationPoupFlag) ? _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "drpPopup"
  }, [_c('div', {
    staticClass: "decisionTitle"
  }, [_c('div', {
    staticClass: "confirmationTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.ensure_upload_txt")))])]), _vm._v(" "), _c('div', {
    staticClass: "drpPopupBtnHolder"
  }, [_c('span', {
    staticClass: "leftBtnPopup",
    on: {
      "click": function($event) {
        return _vm.closeUploadConfirmationPopup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_review_upload")))]), _vm._v(" "), _c('span', {
    staticClass: "rightBtnPopup",
    on: {
      "click": function($event) {
        return _vm.uploadFiles()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.yes_finish_upload")))])])])]) : _vm._e(), _vm._v(" "), (_vm.discardFilesConfirmationPoupFlag) ? _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "drpPopup"
  }, [_c('div', {
    staticClass: "decisionTitle"
  }, [_c('div', {
    staticClass: "confirmationTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.discard_uploadfile_txt")))])]), _vm._v(" "), _c('div', {
    staticClass: "drpPopupBtnHolder"
  }, [_c('span', {
    staticClass: "leftBtnPopup",
    on: {
      "click": function($event) {
        return _vm.closeDiscardFilePopup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_stay_page")))]), _vm._v(" "), _c('span', {
    staticClass: "rightBtnPopup",
    on: {
      "click": function($event) {
        return _vm.moveToLandingPage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.yes_discard_file")))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', {
    staticClass: "backText",
    class: [{
      'opacity5': _vm.isFileUploadInProgress
    }],
    on: {
      "click": function($event) {
        return _vm.backButtonClick()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" " + _vm._s(_vm.$t("message.front_page.back_btn")))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerDiv"
  }, [_c('span', {
    staticClass: "uploadTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.upload_txt")))]), _vm._v(" "), _c('span', {
    staticClass: "metadataTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.metadata_txt")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', {
    staticClass: "filesAndFoldersTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.upload_file")))]), _vm._v(" "), _c('span', {
    staticClass: "fltRight"
  }, [_c('button', {
    staticClass: "completeTask nextPosition",
    class: [{
      'opacity5': _vm.isFileUploadInProgress
    }],
    on: {
      "click": function($event) {
        return _vm.nextButtonClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.next_btn")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("message.upload_page.filename_note")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 drpAndFilesContainer"
  }, [_c('div', {
    staticClass: "drpHolder",
    class: [{
      'moveLeft': _vm.isFilesUploaded
    }]
  }, [_c('div', {
    staticClass: "dropzone",
    attrs: {
      "id": "drpContainer"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show.visible",
      value: (_vm.isFilesUploaded),
      expression: "isFilesUploaded",
      modifiers: {
        "visible": true
      }
    }],
    attrs: {
      "id": "statusContainer"
    }
  }, [_c('div', {
    staticClass: "uploadText"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.uploaded_file")))]), _vm._v(" "), _c('div', {
    staticClass: "dropzone-previews",
    attrs: {
      "id": "previewContainer"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "middleHolder"
  }, [_c('span', {
    staticClass: "completedTask"
  }), _vm._v(" "), _c('span', {
    staticClass: "connectingLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "pendingTask"
  })])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-holder"
  }, [_c('div', {
    staticClass: "content-holder"
  }, _vm._l((_vm.model.dynamicUiData), function(component) {
    return _c('div', {
      staticClass: "modal-body"
    }, [(component.displayType == 'datefield') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "date",
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'number') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "number",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'textarea') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "rows": "3",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'textfield') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "text",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'combobox') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form, component.key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((component.listvalues), function(listvalue) {
      return _c('option', [_vm._v(_vm._s(listvalue.displayname))])
    }), 0)]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'checkbox') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-right-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[component.key]) ? _vm._i(_vm.form[component.key], null) > -1 : (_vm.form[component.key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form[component.key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, component.key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, component.key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, component.key, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "form-left-check"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "validationMsg"
  }, [_vm._v(_vm._s(_vm.validationMessage))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    class: {
      button: true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideMetadataPopup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("\n                        cancel\n                    ")]), _vm._v(" "), _c('button', {
    class: {
      button: true
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("\n                        submit\n                    ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Fields marked with "), _c('span', {
    staticClass: "mandatoryMarkText"
  }, [_vm._v("*")]), _vm._v(" are mandatory")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropzone-form')
},staticRenderFns: []}

/***/ })
],[79]);


// WEBPACK FOOTER //
// static/js/app.011e22ecb0e6d99c97d0.js